module.exports = __webpack_public_path__ + "img/icon_search.e2b0be71.png";